import { gql } from 'apollo-angular';

export const GetScreeningOccupancyByIdDocument = gql`
  query getScreeningOccupancyById($screeningId: String!) {
    getScreeningOccupancyById(screeningId: $screeningId) {
      occupiedSeats
    }
  }
`;
